import {inject, Injectable, OnInit} from "@angular/core";
import {MarkupManagerService} from "@wms/core";
import {findIndex, forEach, get, pullAt, set} from "lodash-es";
import {EventManagerService} from "@wms/app";
import { DialogInfo, ViewMap } from "@wms/components";
import {runtimeEventManager} from "@wm/core";
import { Subscription } from "rxjs";
import { AppManagerService } from "../runtime/services/app.manager.service";


let dialogIdNameMap: {[key: string]: DialogInfo},
  dialogTypeIconNameMap: {[key: string]: string} = {
    'wm-dialog': 'design-dialog',
    'wm-alertdialog': 'alert-dialog',
    'wm-bottomsheet': 'bottomsheet',
    'wm-confirmdialog': 'confirm-dialog',
    'wm-iframedialog': 'iframe-dialog',
    'wm-logindialog': 'login-dialog',
    'wm-pagedialog': 'page-dialog',
  };

@Injectable()
export class PageViewsManager {
  private markupManager: MarkupManagerService;
  private eventManager: EventManagerService;
  private appManager: AppManagerService;
  private views: ViewMap = {
    container: {},
    dialog: [],
    all: {},
    containerIdNameMap: {}
  };
  dialogTypeIconNameMap = {
    'wm-dialog'        : 'design-dialog',
    'wm-alertdialog'   : 'alert-dialog',
    'wm-bottomsheet'   : 'alert-dialog',
    'wm-confirmdialog' : 'confirm-dialog',
    'wm-iframedialog'  : 'iframe-dialog',
    'wm-logindialog'   : 'login-dialog',
    'wm-pagedialog'    : 'page-dialog'
  };
  private registerDestroyListener = new Subscription();

  constructor() {
    this.markupManager = inject(MarkupManagerService);
    this.eventManager = inject(EventManagerService);
    this.appManager = inject(AppManagerService);
    this.registerDestroyListener.add(this.appManager.subscribe('markup-loaded', (triggerClick?: any) => this.onMarkupLoad(triggerClick)));
    this.eventManager.postWidgetDeleteObservable().subscribe(this.onPostWidgetDelete.bind(this));
  }

  onMarkupLoad(triggerClick: boolean) {
    /**Populate the current views */
    this.getPageViews(triggerClick);
    /*Initialize the data types*/
    // initializeDataTypes();
  }

  resetViews() {
    this.views = {
      container: {}, // contains the container views .. views.container[__ctrId__] = []
      dialog: [], // contains the dialogViews .. views.dialog = []
      containerIdNameMap: {}, // map of container WidgetId and Name map
      all: {}  // map of view-widgetId and viewInfo
    };
  }

  isDialogView($view: JQuery<HTMLElement>) {
    return $view.first().is('wm-dialog, wm-alertdialog, wm-confirmdialog, wm-iframedialog, wm-pagedialog, wm-logindialog,wm-bottomsheet');
  }

  getPageViews(triggerClick: boolean) {
    let markup: JQuery<HTMLElement> | undefined = this.markupManager.getMarkup();
    if (!markup) {
      return;
    }
    let _views = $(markup).find('wm-dialog, wm-alertdialog, wm-confirmdialog, wm-iframedialog, wm-pagedialog, wm-logindialog,wm-bottomsheet');

    this.resetViews();

    dialogIdNameMap = {};

    /*Add each view to the set the "views" object.*/
    if (_views?.length) {
      forEach(_views, (view: HTMLElement) => {
        let $dialog: JQuery<HTMLElement> = $(view),
        dialogName = $dialog.attr('name'),
        dialogWidgetId = $dialog.attr('widgetid'),
        $parent = $dialog.parent(),
        parentWidgetId = $parent.attr('widgetid'),
        childWidgetType: any = $dialog.attr('widgettype'),
        dialogInfo = {
          name: $dialog.attr('name'),
          widgetId: dialogWidgetId || '',
          parentWidgetId: parentWidgetId || '',
          displayName: dialogName || '',
          iconClass: dialogTypeIconNameMap[childWidgetType]
        };

        if (childWidgetType) {
          dialogInfo.iconClass = dialogTypeIconNameMap[childWidgetType];
        }

        if (this.isDialogView($dialog)) {
          dialogInfo.displayName = $dialog.attr('name') || '';
          if (dialogWidgetId) {
            dialogIdNameMap[dialogWidgetId] = dialogInfo;
          }
          this.views.dialog.push(dialogInfo);
        } else if (parentWidgetId) {
          if (!this.views.container[parentWidgetId]) {
            this.views.container[parentWidgetId] = [];
            this.views.containerIdNameMap[parentWidgetId] = $parent.attr('name') || '';
          }
          this.views.container[parentWidgetId].push(dialogInfo);
        }
        if (dialogWidgetId) {
          this.views.all[dialogWidgetId] = dialogInfo;
        }
      });
    }
    runtimeEventManager.emit('update-view', {'views': this.views, triggerClick});
  }

  onNameChange(event: Event, widgetId: string, nv: string) {
    let view;

    //when the name of a view is changed.
    view = this.views.all[widgetId];
    if (view) {
      view.name = nv;
      view.displayName = nv;
      return;
    }

    //when the name of a view container is changed.
    view = this.views.containerIdNameMap[widgetId];
    if (view) {
      set(this.views.containerIdNameMap, widgetId, nv);
      return;
    }

    //when the name of a dialog is changed.
    view = dialogIdNameMap[widgetId];
    if (view) {
      dialogIdNameMap[widgetId].displayName = nv;
    }
  }

  onPostWidgetDelete(data: {widgetId: string, parentWidgetId: string}) {
    let _views, parentWidgetId = data.parentWidgetId, widgetId = data.widgetId;
    let parentWidgetViews = this.views.container[parentWidgetId];

    // if the deleted widget is a view
    if (this.views.all[widgetId]) {
    _views = parentWidgetViews || this.views.dialog;

    if (_views) {
      pullAt(_views, findIndex(_views, {'widgetId': widgetId}));
    }

    // if there are no more views inside the container. delete the container from the map
    if (parentWidgetViews && !parentWidgetViews.length) {
      delete this.views.container[parentWidgetId];
    }

    delete this.views.all[widgetId];
    } else {
      // if the deleted widget is a container.. remove it from the map.
      if (this.views.container[widgetId]) {
        delete this.views.container[widgetId];
      }
    }
    this.eventManager.emitViewUpdateOnDelete(data);
  }

}
